import React from "react";
import axios from "axios";
import { API_BASE_URL } from '../config';
export default function AccountProfile({
  interimProfileData,
  handleChange,
  unsavedChanges,
  saveProfile,
  profileSaveStatus,
}) {
  return (
    <div className="account-content-subcontainer">
      <div className="account-content-subcontainer-item">
        <h4>First Name</h4>
        <input value={interimProfileData?.firstName} onChange={handleChange("firstName")} />
      </div>

      <div className="account-content-subcontainer-item">
        <h4>Last Name</h4>
        <input value={interimProfileData?.lastName} onChange={handleChange("lastName")} />
      </div>

      <div className="account-content-subcontainer-item">
        <h4>Email</h4>
        <input value={interimProfileData?.email} disabled />
        <i>Please contact support to assist with an email change.</i>
      </div>

      <div className="account-content-subcontainer-item account-content-subcontainer-item-button">
        <button type="button" onClick={async () => {
          const email = interimProfileData?.email;

          try {
            const res = await axios.post(`${API_BASE_URL}/api/auth/forgot-password`, { email });
            if (res.status === 200) {
              alert(res.data?.message || "If an account exists, a reset link has been sent to the email provided.");
            }
          } catch (err) {
            const serverMsg = err.response?.data?.message;
            console.log("Error during password reset request:", err);
            console.log("email:", email);
            alert(serverMsg || err.message || "Unable to process request. Please try again.");
          }
        }}>Send Password Reset</button>
      </div>

      <div className="account-content-subcontainer-item account-content-subcontainer-item-save-button">
        {unsavedChanges && (
          <button
            type="button"
            onClick={saveProfile}
            disabled={profileSaveStatus === "saving"}
          >
            {profileSaveStatus === "saving" ? "Saving..." : "Save Changes"}
          </button>
        )}

        {profileSaveStatus === "saved" && (
          <i style={{ color: "green" }}>Changes saved!</i>
        )}

        {profileSaveStatus === "error" && (
          <i style={{ color: "red" }}>Save failed. Please try again.</i>
        )}
      </div>
    </div>
  );
}